import { useTranslation } from 'react-i18next';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FaTrashAlt } from 'react-icons/fa';
import Button from 'react-bootstrap/Button';

function DeleteButton({ handler, label }: { handler: () => void, label: string }): JSX.Element {
  const { t } = useTranslation();

  return (
    <OverlayTrigger
      trigger={['hover', 'focus']}
      placement="left"
      overlay={(
        <Tooltip id="delete-button-tooltip">
          {t('Delete_Action_Description')}
        </Tooltip>
      )}
    >
      <Button variant="link" className="linkactions" onClick={handler}>
        <FaTrashAlt />
        {label && (<span>{label}</span>)}
      </Button>
    </OverlayTrigger>
  );
}

export default DeleteButton;
